@if (isShowing) {

@if (positionBackBtnInTopLeft && !!pageTitleToGoBackTo) {
<button id="back-button" class="position-tl" (click)="handleGoBack()" [matTooltip]="backButtonTooltip">
  <icon name="back_arrow"></icon>
</button>
}

<nav id="quick-nav" [class.is-standalone]="isStandalone" [class.show-back-button]="!!pageTitleToGoBackTo" [class.full-width]="usePermanentBottomNav"
     [class.no-adjust-needed]="positionBackBtnInTopLeft">
  <div class="main-container">
    <div class="logo-container">
      @if (!positionBackBtnInTopLeft) {
      <button id="back-button" (click)="handleGoBack()" [matTooltip]="backButtonTooltip">
        <icon name="back_arrow"></icon>
      </button>
      }
      <div class="logo" [style.background-image]="logoUrl | safeBackgroundImageUrl" (click)="goHome()">
        @if (!logoUrl) {
        <span>Home</span>
        }
      </div>
      @if(secondaryCommunityLink){
      <a class="secondary-comm-link" [href]="secondaryCommunityLink.url">
        {{secondaryCommunityLink.name}}
      </a>
      }
    </div>
    @if (primaryModules.length) {
    <div id="primary-modules" #scrollingContainer [class.top-border-radius]="!secondaryModules.length">
      <div class="centering-container">
        @for (module of primaryModules; track trackById($index, module)) {
        <button (click)="handleModuleNavigation(module)" [class.selected]="module.IsSelected"
                [class.expanded-brochure-button]="module.UniqueName === brochureUniqueName && !!totalFavorites"
                [matTooltip]="usePermanentBottomNav ? '' : module.Tooltip">
          @if (module.IsDownloadLink) {
          <icon name="download" class="module-download-icon"></icon>
          }
          @if(module.UniqueName === brochureUniqueName) {
          <favorites-counter [count]="totalFavorites"></favorites-counter>
          }
          @if (!usePermanentBottomNav) {
          <div class="icon-center" [class.with-short-name]="showShortName">
            @if(module.UniqueName !== brochureUniqueName) {
            <icon [name]="module.IconName" [svg]="module.IconSvg"></icon>
            }
            @if (showShortName && module.UniqueName !== brochureUniqueName) {
            <div class="short-name">
              {{module.ShortName}}
            </div>
            }
          </div>
          }
          @if (usePermanentBottomNav) {
          <h3>{{module.Title}}</h3>
          }
        </button>
        }
      </div>
    </div>
    }
    @if (secondaryModules.length && !usePermanentBottomNav) {
    <div id="secondary-modules" [class.expanded]="isExpanded">
      @for (module of secondaryModules; track trackById($index, module)) {
      <button (click)="handleModuleNavigation(module)" [class.selected]="module.IsSelected"
              [class.expanded-brochure-button]="module.UniqueName === brochureUniqueName && !!totalFavorites" [matTooltip]="module.Tooltip">
        @if (module.IsDownloadLink) {
        <icon name="download" class="module-download-icon"></icon>
        }
        @if(module.UniqueName === brochureUniqueName) {
        <favorites-counter [count]="totalFavorites"></favorites-counter>
        }
        <div class="icon-center" [class.with-short-name]="showShortName">
          @if(module.UniqueName !== brochureUniqueName) {
          <icon [name]="module.IconName" [svg]="module.IconSvg"></icon>
          }
          @if (showShortName && module.UniqueName !== brochureUniqueName) {
          <div class="short-name">
            {{module.ShortName}}
          </div>
          }
        </div>
      </button>
      }
      <button class="expander" [class.expanded]="isExpanded" (click)="handleExpandToggle()">
        <icon name="sub_menu_slide"></icon>
      </button>
    </div>
    }
    @if (usePermanentBottomNav) {
    <div id="nav-tools">
      @if (showScrollArrows) {
      <icon-button class="arrow left" [class.hide]="!canScrollLeft" icon="carrot_arrow" (click)="handleScrollStep(-1)"></icon-button>
      }
      @if (showScrollArrows) {
      <icon-button class="arrow right" [class.hide]="!canScrollRight" icon="carrot_arrow" (click)="handleScrollStep(1)"></icon-button>
      }
      @if (pinModule) {
      <icon-button [icon]="pinModule.IconName" (click)="handleModuleNavigation(pinModule)" [matTooltip]="pinModule.Tooltip">
      </icon-button>
      }
      @if (registrationModule) {
      @if(registrationButtonText) {
      <button class="registration-button" (click)="handleModuleNavigation(registrationModule)" [matTooltip]="registrationModule.Tooltip">
        {{registrationButtonText}}
      </button>
      }@else {
      <icon-button [icon]="registrationModule.IconName" (click)="handleModuleNavigation(registrationModule)"
                   [matTooltip]="registrationModule.Tooltip"></icon-button>
      }

      }
      @if (registrationModule?.ShowResetButton) {
      <icon-button icon="reset_arrow" (click)="handleResetSession()" [matTooltip]="registrationModule.ResetButtonTooltip"></icon-button>
      }
    </div>
    }
  </div>
</nav>
}